import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Translation } from '@xfeet-workspace/xfeet-api-client/models';

/*
 * translate the value
 * Usage:
 *   value | modelTranslate
*/
@Pipe({
    name: 'modelTranslate',
    standalone: false
})
export class ModelTranslatePipe implements PipeTransform {

  private _notFoundStr = '';

  constructor(private translate: TranslateService) {

  }

  transform(translations?: Translation[], typeLabel: string = 'label', language?: string, replacements?: any): string {
    const lang = language ? language : this.translate.currentLang;
    //console.log(lang, this.translate.currentLang);

    if (translations?.length) {
      const tFound = translations.find(
        (t: Translation) => t.language.code === lang
      );
      if (tFound) {
        if ( typeLabel === 'label') {
         return this.optionalReplacements(tFound.translatedLabel, replacements);
        }
        if ( typeLabel === 'description') {
            return this.optionalReplacements(tFound.translatedDescription, replacements);
        }
        // abr
        return this.optionalReplacements(tFound.translatedLabelAbr, replacements);
      }
    }
    return this._notFoundStr;
  }

  optionalReplacements(translatedStr: string, replacements?: any): string {
    if (replacements) {
      Object.keys(replacements).forEach((key) => {
        if (translatedStr.indexOf(`{${key}}`) > -1) {
          translatedStr = translatedStr.replace(`{${key}}`, replacements[key]);
        }
      });
    }
    return translatedStr;
  }

}
